import { atom } from 'jotai';

export const introductionPresentationAtom = atom(false);